export const STATIC_ADDRESSES = <const>{
  contractHelpers: '0x842899ECF380553E8a4de75bF534cdf6fBF64049',
  collectionHelpers: '0x6C4E9fE1AE37a41E93CEE429e8E1881aBdcbb54F',
}
export const NESTING_PREFIX = <const>'0xf8238ccfff8ed887463fd5e0'
export const COLLECTION_ADDRESS_PREFIX = <const>'0x17c4e6453cc49aaaaeaca894e6d9683e'
